// Shared entrance for the big rounded cards (Projects, Education).
// The card drives its children: the card rises in, then its image unveils bottom-up.
// (An image can't observe itself: a fully clipped element never reports as in view.)
export const EASE = [0.22, 1, 0.36, 1];

export const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  show: (delay = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE, delay } }),
};

export const imageVariants = {
  hidden: { clipPath: "inset(100% 0% 0% 0% round 1.4rem)" },
  show: (delay = 0) => ({
    clipPath: "inset(0% 0% 0% 0% round 1.4rem)",
    transition: { duration: 1, ease: EASE, delay: delay + 0.15 },
  }),
};

export const cardInView = {
  initial: "hidden",
  whileInView: "show",
  viewport: { once: true, amount: 0.15 },
  whileHover: { y: -6, transition: { duration: 0.3 } },
};
